import { ResolverProps } from '../utils/resolverHelpers';
import { timelineMapper } from './mapper';
import SectionTitleContainer from '../titles';
import TimelineView from './TimelineView';

const TimelineResolver = (props: ResolverProps<'timeline'>) => {
  const data = timelineMapper(props.section);
  return (
    <SectionTitleContainer {...props} data={data.titles} variant="standard">
      <TimelineView data={data} />
    </SectionTitleContainer>
  );
};

export default TimelineResolver;
